
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forgot_password",
      function () {
        return require("private-next-pages/forgot_password.tsx");
      }
    ]);
  